var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"segment footer"},[_c('span',{staticStyle:{"margin-top":"16px"}}),_c('img',{attrs:{"src":require("@/assets/2026/berget-logo-26-2.png")}}),_c('span',{staticStyle:{"margin-top":"32px","font-size":"17px"}},[_vm._v("Copyright Berget Events AB 2026. All rights reserved.")])])
}]

export { render, staticRenderFns }